// Lazy-loader for the CodeMirror 6 chunk built at packages/ui-web/scripts/build.mjs
// (target: _lib/cm-editor.entry.js -> dist/cm-editor.js). The chunk is an IIFE
// that attaches window.mindexEditor = { createMarkdownEditor }.
//
// loadCodeMirror() is idempotent: first call injects <script>, second+ calls
// return the same in-flight promise so two simultaneous edit-mode toggles
// don't race.

let _promise = null;

export function _resetForTests() { _promise = null; }

export function loadCodeMirror() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('CodeMirror chunk requires window'));
  }
  if (window.mindexEditor) return Promise.resolve(window.mindexEditor);
  if (_promise) return _promise;
  _promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/cm-editor.js';
    script.async = true;
    script.dataset.mindexCm = '1';
    script.addEventListener('load', () => {
      if (window.mindexEditor) resolve(window.mindexEditor);
      else reject(new Error('CodeMirror chunk loaded but window.mindexEditor missing'));
    });
    script.addEventListener('error', () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      _promise = null;
      reject(new Error('CodeMirror chunk failed to load'));
    });
    document.head.appendChild(script);
  });
  return _promise;
}
